var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDone = function SvgDone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1401 5.33331L8.88897 15.5844L4.86008 11.5711L2.66675 13.7644L8.88897 19.9866L21.3334 7.5422L19.1401 5.33331Z",
    fill: "currentColor"
  })));
};

export { SvgDone as ReactComponent };
export default __webpack_public_path__ + "f142beaa6ca8565eb5b4aa7084b6b5a0.svg";